module.exports = __webpack_public_path__ + "nc_static/media/validated.528c0779.svg";